import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  HangerList,
  LumberListPrototype,
  OrganizationMaterialSetPrototype,
  PlateList,
} from '@paragon/contract-library';

type MaterialSetPrototypeState =
  | { readonly status: 'loading' }
  | {
      readonly status: 'loaded';
      readonly lumberListPrototypes: { readonly [guid: string]: LumberListPrototype };
      readonly plateLists: { readonly [guid: string]: PlateList };
      readonly hangerLists: { readonly [guid: string]: HangerList };
    };

const initialState: MaterialSetPrototypeState = { status: 'loading' };

const materialSetPrototypeSlice = createSlice({
  name: 'materialSetPrototype',
  initialState: initialState as MaterialSetPrototypeState,
  reducers: {
    materialSetPrototypeLoaded: (_, action: PayloadAction<OrganizationMaterialSetPrototype>) => ({
      status: 'loaded',
      lumberListPrototypes: action.payload.lumberLists,
      plateLists: action.payload.plateLists,
      hangerLists: action.payload.hangerLists,
    }),
  },
});

export const { materialSetPrototypeLoaded } = materialSetPrototypeSlice.actions;
export const materialSetPrototype = materialSetPrototypeSlice.reducer;
